"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContextHistory = void 0;
var _core = require("@focaltec-suite/core");
var _react = require("react");
var _reactRouter = require("react-router");
var useContextHistory = exports.useContextHistory = function useContextHistory() {
  var context = (0, _react.useContext)(_core.AppContext);
  var history = (0, _reactRouter.useHistory)();
  var location = (0, _reactRouter.useLocation)();
  var state = history.location.state;
  var previousPathname = (0, _react.useMemo)(function () {
    var _a;
    return ((_a = state === null || state === void 0 ? void 0 : state.previous) === null || _a === void 0 ? void 0 : _a.pathname) || undefined;
  }, [state]);
  var pushRoute = (0, _react.useCallback)(function (path) {
    var pathname = context.fixPath(path);
    history.push({
      pathname: pathname,
      state: {
        previous: location
      }
    });
  }, [context, history, location]);
  var contextHistory = (0, _react.useMemo)(function () {
    return {
      previousPathname: previousPathname,
      pushRoute: pushRoute
    };
  }, [previousPathname, pushRoute]);
  return contextHistory;
};